import React from 'react'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faGithub, faInstagram, faLinkedin } from '@fortawesome/free-brands-svg-icons';

export default function Social({ social }) {
    const getIcon = (iconName) => {
        switch (iconName) {
            case 'instagram': return faInstagram;
            case 'linkedin': return faLinkedin;
            case 'github': return faGithub;
            default: return null;
        }
    };

    return (
        <div className='home__social'>
            {social.map((item, index) => (
                <a key={index} href={item.url} className='home__social-icon' target='_blank' rel="noreferrer">
                    <FontAwesomeIcon icon={getIcon(item.icon)} />
                </a>
            ))}
        </div>
    )
}
